import clsx from "clsx";
import { Text } from "./base";
import { EvaluationStatus } from "../redux/reducers/evaluationSlices";

type EvaluationStatusPillProps = {
  status: EvaluationStatus;
};

const STATUS_LABEL: Record<EvaluationStatus, string> = {
  complete: "Completed",
  pending: "Pending",
  error: "Error",
  skipped: "Skipped",
};

export const EvaluationStatusPill = ({ status }: EvaluationStatusPillProps) => {
  return (
    <Text
      className={clsx(
        "w-auto px-2 py-0.5 rounded-full text-xs",
        status === "complete" && "bg-success/10 dark:bg-success/20 text-success-dark dark:text-success-light",
        status === "pending" && "bg-yellow-100 dark:bg-yellow-900/40 text-yellow-800 dark:text-yellow-300",
        status === "error" && "bg-error/10 dark:bg-error/20 text-error-dark dark:text-error-light",
        // Skipped is a non-event, not a failure — surface it as neutral so
        // reviewers don't read it as a problem.
        status === "skipped" && "bg-gray-100 dark:bg-gray-700/40 text-gray-700 dark:text-gray-300",
      )}
    >
      {STATUS_LABEL[status] ?? status}
    </Text>
  );
};
